// mutations types

export const CLEAR_TOKEN = 'CLEAR_TOKEN' // 清空 auth token

export const SAVE_TOKEN = 'SAVE_TOKEN' // 保存 auth token

export const SAVE_PAYLOAD = 'SAVE_PAYLOAD' // 保存 auth token

export const SET_LOADING = 'SET_LOADING' // 全局加载状态

export const SET_NOTICE_NUM = 'SET_NOTICE_NUM' // 通知数